export class UtenteComune {
  utenteId;
  comuneId;
  emailIstituzionale;
  telefonoIstituzionale;
  tipologia;
}
